<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="sapMaterialPullingPlanPlans/getDeliveryPlanPage"
        @delete="deleteHandle"
        @select="selectHandle"
        @reset="resetHandle">
      <template slot="otherBtn">
        <el-button v-if="createAuth" type="primary" :disabled="!selection.length" @click="createPurchasePlan"> 创建要货计划</el-button>
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="物料号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入物料号" clearable/>
          </el-form-item>
          <el-form-item label="物料名称">
            <el-input v-model.trim="filter.materialName" placeholder="请输入物料名称" clearable/>
          </el-form-item>
          <el-form-item label="发货单号">
            <el-input v-model.trim="filter.deliveryBillNo" placeholder="请输入发货单号" clearable/>
          </el-form-item>
          <el-form-item label="采购组">
            <el-input v-model.trim="filter.buyName" placeholder="请输入" clearable/>
          </el-form-item>
<!--          <el-form-item label="创建时间">-->
<!--            <el-date-picker-->
<!--                v-model="createTimeRange"-->
<!--                type="daterange"-->
<!--                range-separator="至"-->
<!--                start-placeholder="开始时间"-->
<!--                end-placeholder="结束时间"-->
<!--                value-format="yyyy-MM-dd"-->
<!--                @change="dateRangeChange('createTimeRange', 'createTimeBegin', 'createTimeEnd')"/>-->
<!--          </el-form-item>-->
<!--          <el-form-item label="对接时间">-->
<!--            <el-date-picker-->
<!--                v-model="addDateRange"-->
<!--                type="daterange"-->
<!--                range-separator="至"-->
<!--                start-placeholder="开始时间"-->
<!--                end-placeholder="结束时间"-->
<!--                value-format="yyyy-MM-dd"-->
<!--                @change="dateRangeChange('addDateRange', 'addDateBegin', 'addDateEnd')"/>-->
<!--          </el-form-item>-->
        </el-form>
      </template>
    </viewTable>
    <create-purchase-plan-dialog ref="createPlan"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import CreatePurchasePlanDialog from "@/views/PurchaseOrderManager/PurchasePlan/CreatePurchasePlanDialog";

  export default {
    name: "PurchasePlanAdd",
    components: {CreatePurchasePlanDialog, viewTable},
    data() {
      return {
        limits: {
          // editAuth: this.$auth(0),
        },
        createAuth: this.$auth(456),
        submitLoading: false,
        createTimeRange:[],
        addDateRange:[],
        pickerOptions: {
          shortcuts: [{
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          }],
        },
        selection: [],
        createTime: "",
        filter: {
          materialNo: "",
          materialName: "",
          deliveryBillNo: "",
          createTimeBegin:"",
          createTimeEnd:"",
          addDateBegin:"",
          addDateEnd:"",
        },
        columnsProperty: [
          {
          tooltip: true,
            key: "materialNo",
            align: "center",
            width: 120,
          },
          {
            key: "materialName",
            align: "center",
            width: 300,
            tooltip: true,
          },
          {
            key: "statusName",
            align: "center",
            width: 100,
            tooltip: true,
          },
          {
            key: "buyName",
            align: "center",
            width: 100,
            tooltip: true,
          },
          {
            key: "createDate",
            align: "center",
            width: 160,
            tooltip: true,
          },
          {
            key: "addTime",
            align: "center",
            width: 160,
            tooltip: true,
          },
          {
            key: "updateTime",
            align: "center",
            width: 160,
            tooltip: true,
          },
          {
            key: "nextCycle",
            align: "center",
            width: 100,
            tooltip: true,
          },
          {
            key: "nextGap",
            align: "center",
            width: 100,
            tooltip: true,
          },
          {
            key: "nextTwoWeekCycle",
            align: "center",
            width: 100,
            tooltip: true,
          },
          {
            key: "nextTwoWeekGap",
            align: "center",
            width: 100,
            tooltip: true,
          },
          {
            key: "thisWeekDeliveryDate",
            align: "center",
            width: 120,
            tooltip: true,
          },
          {
            key: "nextWeekDeliveryDate",
            align: "center",
            width: 120,
            tooltip: true,
          },
          {
            key: "deliveryBillNo",
            align: "center",
            width: 120,
            tooltip: true,
          },
          {
            key: "action",
            align: "center",
            width: 80,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      submitHandle(row) {
        this.$confirm("确定提交吗?", "提示", {type: "warning"}).then(() => {
          this.submitLoading = true;
          this.$http.get("basic", `sapMaterialPullingPlanPlans/submit/${row.pkid}`).then((resp) => {
            if (resp.success) {
              this.$message.success("提交成功");
              this.submitLoading = false;
              this.loadData();
            }
          });
        });
      },
      selectHandle(selection) {
        this.selection = selection;
      },
      resetHandle(filter) {
        this.filter = filter;
      },
      deleteHandle(row) {
        this.$http.delete("basic", "sapMaterialPullingPlanPlans", row.pkid).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },
      createPurchasePlan() {
        console.log(this.selection);
        const statusArr = this.selection.filter(item => item.status === 20).length;
        if (statusArr) {
          return this.$message.error("请选择未确认的物料！");
        }
        if (!this.selection.length) {
          this.$confirm("请选择物料", "错误", {
            type: "error",
            showCancelButton: false,
          });
        } else {
          this.selection.map(item => {
            item.planType = 2;
          });
          this.$router.push({
            path: "/PurchasePlanPreview",
            query: {
              selection: this.selection,
            },
          });
        }
      },
      changeUrgent(id) {
        this.$http.get("basic", `sapMaterialPullingPlanPlans/changeUrgent/${id}`).then((resp) => {
          if (resp.success) {
            this.$message.success("修改成功");
          }
          this.loadData(1);
        }).catch(() => {
          this.$message.error("修改失败");
        });
      },
    },
  };
</script>
